import { controls } from "../../controls";

const rp454 = {
  label: "Agri Namuna No. 4",
  pageLabel: "Agri Namuna No. 4",
  starting: true,
  url: "rp454",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "From Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Namuna No.4\nSociety wise/Branch wise M.T. Agri Loan Demand",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Name Of Branch/Society",
        accessor: "descn",
        width: 250,
        rwidth: "*"
      },
      {
        Header: "L.T. Samarth",
        columns: [
          {
            Header: "Overdue",
            accessor: "LT_samarth_overdue",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Current",
            accessor: "LT_samarth_current",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Total",
            accessor: "LT_samarth_total",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'LT_samarth_overdue' }, { source: 'row', field: 'LT_samarth_current' },
              ], resultVar: 'total'
            }],
            type: "currency",
            rwidth: 50
          }
        ]
      },
      {
        Header: "L.T. Asamarth",
        columns: [
          {
            Header: "Overdue",
            accessor: "LT_Asamarth_overdue",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Current",
            accessor: "LT_Asamarth_current",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Total",
            accessor: "LT_Asamarth_total",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'LT_Asamarth_overdue' }, { source: 'row', field: 'LT_Asamarth_current' },
              ], resultVar: 'total'
            }],
            type: "currency",
            rwidth: 50
          }
        ]
      },
      {
        Header: "Total",
        columns: [
          {
            Header: "Overdue",
            accessor: "total_overdue",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'LT_samarth_overdue' }, { source: 'row', field: 'LT_Asamarth_overdue' },
              ], resultVar: 'total'
            }],
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Current",
            accessor: "total_current",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'LT_samarth_current' }, { source: 'row', field: 'LT_Asamarth_current' },
              ], resultVar: 'total'
            }],
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Total",
            accessor: "grand_total",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'LT_samarth_overdue' }, { source: 'row', field: 'LT_Asamarth_overdue' },
              { source: 'row', field: 'LT_samarth_current' }, { source: 'row', field: 'LT_Asamarth_current' },
              ], resultVar: 'total'
            }],
            type: "currency",
            rwidth: 50
          }
        ]
      }
    ]
  }
};

export default rp454;